import { types } from './remessapagamento.actions'
import { Reducer } from '../../services/reducer.factory'
import storage from '../../services/stoage.service'
import _ from 'lodash'
import { getValorVencimentoFromCodigoBarrasLinhaDigitavel } from '../../utils'

const initialState = {
  id: 'remessaPagamento',
  columns: [],
  currentRecord: {
    unidade: '',
    contaCorrente: '',
    dataPagamento: '',
    taxa: '',
  },
  item: {
    beneficiario: '',
    taxa: '',
    dataPagamento: '',
    codigoBarras: '',
    valor: '',
    dataVencimento: '',
    valorVencimentoByCodigoBarras: true,
  },
  itens: [],
  // PHOENIX-959: envio do Gerar - null (livre), ENVIANDO ou INCERTO (sem resposta: pode ter pago; so recarregando).
  // No store, e nao no componente: sair da tela e voltar nao libera o Gerar com os mesmos itens.
  envioGerar: null,
  messages: null,
  selectedFilters: [],
  usaListDto: false,
}

const reducer = new Reducer(initialState, types)

export function CRUDRemessaPagamentoReducer(state, action) {
  if (state) {
    state.messages = storage.getAppLabels('remessapagamento')
  }
  state = reducer.execute(state, action)
  return execute(state, action)
}

function execute(state, action) {
  switch (action.type) {
    case types.RESET:
      return reset(state, action)
    case types.ENVIO_GERAR:
      return Object.assign({}, state, { envioGerar: action.payload })
    case types.ADD_ITEM:
      return addItem(state, action)
    case types.SET_ITEM:
      return setItem(state, action)
    case types.ON_CLICK_REMOVE_ITEM:
      return onClickRemoveItem(state, action)
    default:
      return state
  }
}

// depois da remessa gerada: os itens ja foram pagos, nao ficam na tela para um segundo Gerar (array novo: o addItem
// faz push no array do estado, inclusive no do initialState)
function reset(state, action) {
  return {
    ...state,
    currentRecord: initialState.currentRecord,
    itens: [],
    envioGerar: null,
  }
}

function addItem(state, action) {
  const itens = state.itens || []
  action.payload.hash = new Date().getTime()
  itens.push(action.payload)
  return Object.assign({}, state, {
    item: {
      beneficiario: '',
      taxa: _.get(state, 'currentRecord.taxa', ''),
      dataPagamento: _.get(state, 'currentRecord.dataPagamento', ''),
      codigoBarras: '',
      valor: '',
      dataVencimento: '',
      valorVencimentoByCodigoBarras: true,
    },
    itens,
  })
}

function setItem(state, action) {
  const item = state.item || {}
  item[action.prop] = action.value
  if (action.prop === 'codigoBarras') {
    const { dataVencimento, valor } = getValorVencimentoFromCodigoBarrasLinhaDigitavel(action.value)
    item.dataVencimento = dataVencimento
    item.valor = valor
    item.valorVencimentoByCodigoBarras = !!(dataVencimento && valor)
  }
  return Object.assign({}, state, { item })
}

function onClickRemoveItem(state, action) {
  const newItens = state.itens.filter((i) => i.hash !== action.payload.hash)
  return Object.assign({}, state, { itens: newItens })
}
